/* MoreActions — shared "⋯" menu for destructive & maintenance actions.
   Destructive items open an AlertDialog naming the affected customer/record. */
import React, { useState } from "react";
import { MoreHorizontal } from "lucide-react";
import {
    DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import {
    AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
    AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

export function MoreActions({ subject, items, testid = "more-actions" }) {
    const [pending, setPending] = useState(null);
    return (
        <span onClick={(e) => e.stopPropagation()}>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button
                        data-testid={testid}
                        title="More actions"
                        className="rounded-full border border-cafe-espresso/20 text-cafe-mocha hover:bg-cafe-cream h-9 w-9 inline-flex items-center justify-center transition-colors"
                    >
                        <MoreHorizontal className="h-4 w-4" />
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="min-w-[190px]">
                    {items.filter(Boolean).map((it) => (
                        <DropdownMenuItem
                            key={it.label}
                            data-testid={it.testid}
                            onClick={() => (it.confirm ? setPending(it) : it.onClick())}
                            className={it.danger ? "text-red-700 focus:text-red-700" : ""}
                        >
                            {it.label}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>

            <AlertDialog open={!!pending} onOpenChange={(o) => { if (!o) setPending(null); }}>
                <AlertDialogContent data-testid="confirm-dialog">
                    <AlertDialogHeader>
                        <AlertDialogTitle>{pending?.label}</AlertDialogTitle>
                        <AlertDialogDescription asChild>
                            <div>
                                <p>{pending?.confirm}</p>
                                <p className="mt-3 font-semibold text-cafe-espresso" data-testid="confirm-subject">
                                    Affected: {subject}
                                </p>
                            </div>
                        </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <AlertDialogCancel data-testid="confirm-cancel">Cancel</AlertDialogCancel>
                        <AlertDialogAction
                            data-testid="confirm-proceed"
                            className={pending?.danger ? "bg-red-700 hover:bg-red-800 text-white" : ""}
                            onClick={() => { const f = pending?.onClick; setPending(null); f && f(); }}
                        >
                            {pending?.confirmLabel || "Confirm"}
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </span>
    );
}
